import _ from "lodash";
import { getIn } from "formik";
import moment from "moment/moment";
import React from "react";

import { Checkbox, Text, TextColors, TextTypes } from "@/component-library";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { testLocator } from "@/lib/helpers/test-locator";

import "./ProviderSignatureField.styles.scss";

export const ProviderSignatureField = ({ formikProps, isViewOnly, name, nameToSign, testId }) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);
  const signature = formikProps.values[name];

  const handleChange = async (event) => {
    let value = "";
    let date = "";

    if (event.target.checked) {
      value = nameToSign;
      date = moment().format("MM/DD/YYYY");
    }

    await formikProps.setFieldValue(name, value);
    await formikProps.setFieldValue("signature_date", date);
  };

  return (
    <>
      {isViewOnly && (
        <div className="ProviderSignatureField--view_only_wrapper">
          <p className="ProviderSignatureField--title">Signature</p>
          <p
            className={signature !== "" ? "tw:font-signature tw:text-lg" : undefined}
            {...getAutomationDataAttr(testId)}
            {...testLocator(testId)}
          >
            {signature === "" ? "None" : signature}
          </p>
        </div>
      )}

      {!isViewOnly && (
        <div className="ProviderSignatureField--wrapper">
          <label
            className="ProviderSignatureField--click_to_sign_wrapper"
            {...testLocator(`${testId}-label`)}
          >
            <Checkbox
              checked={_.get(formikProps.values, name) !== ""}
              disabled={isViewOnly}
              onClick={handleChange}
              {...getAutomationDataAttr(`${testId}-checkbox`)}
              {...testLocator(`${testId}-checkbox`)}
            />

            <div>
              <p className="ProviderSignatureField--title">Click to Sign</p>
              {errorMessage && isTouched && (
                <Text
                  color={TextColors.red}
                  layout="block"
                  type={TextTypes.small}
                  {...testLocator(`${testId}-error`)}
                >
                  {errorMessage}
                </Text>
              )}
            </div>
          </label>

          <div className="ProviderSignatureField--signature_line tw:font-signature">
            {"X " + formikProps.values[name]}
          </div>
        </div>
      )}
    </>
  );
};
